import { secureStorage } from './secureStorage';

export const getStoredToken = (): string | null => {
  // Try secure storage first
  const secureToken = secureStorage.getItem('token');
  if (secureToken) {
    return secureToken;
  }
  
  // Try auth-ts structure
  const authData = localStorage.getItem("auth-ts");
  if (authData) {
    try {
      const parsed = JSON.parse(authData);
      return parsed.token ?? null;
    } catch {
      // corrupted JSON in localStorage → fallback
    }
  }

  return localStorage.getItem("token");
};
